import React, {useContext} from 'react'
import Navbar from '../../navbar/Navbar'
import * as Yup from "yup"
import { useFormik } from 'formik'
import { AuthContext } from '../../../context/AuthContext'


const formShema = Yup.object({
     email: Yup.string().email().required()
})

const ResetPassword = () => {

     const {resetPasswordToken, errorForgetPassword} = useContext(AuthContext)

     const formik = useFormik({
          initialValues: {
               email: "",
          },
          onSubmit: (values) => {
               resetPasswordToken(values);
          },
          validationSchema: formShema
     })

  return (
    <div className="container">
         <Navbar />
         <div className="columns is-flex is-justify-content-center">
              <div className="column is-two-fifths">
                   <h1 
                   className='has-text-white is-size-3 has-text-centered mb-6 mt-5 pt-5'>
                        Forget Password Form
                   </h1>
                   <form onSubmit={formik.handleSubmit} className='p-6 has-background-dark box'>
                        <h1 className='has-text-white is-size-4 has-text-centered mb-6'>
                             Enter your email
                        </h1>

                        <h1 className='has-text-danger is-size-5 has-text-centered mb-2'>
                             {errorForgetPassword}
                        </h1>
                        <div className="field">
                             <label className="label"> Email </label>
                             <div className="control">
                             <input 
                             type="email"
                              className='input'
                               placeholder='Your Email'
                               value={formik.values.email}
                               onChange={formik.handleChange("email")}
                               onBlur={formik.handleBlur("email")}
                               />
                               <p className='help is-danger'>
                                    {formik.touched.email && formik.errors.email}
                               </p>
                             </div>
                        </div>

                        <div className="field">
                             <button 
                             className='button is-success is-fullwidth mt-5'
                              type='submit'> Send Activation Link  </button>
                        </div>
                   </form>
              </div>
         </div>
    </div>
  )
}

export default ResetPassword
